import React from 'react';
import {createRoot} from 'react-dom/client';
import { Root } from './components/Root';
import { configure } from 'mobx';

configure({
    enforceActions: 'never'
}); /*store with services*/


class App
{
    constructor()
    {
        this.render();
    }

    private render(): void
    {
        let element = document.getElementById("app");
        createRoot(element)?.render(React.createElement(Root, { app: this }));
    }
}

new App();
